var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-tabs",
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "单笔付款" } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "App Name" } },
                    [_c("el-select", [_c("el-option")], 1)],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "ChannelCode" } },
                    [_c("el-input", { attrs: { disabled: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "PayType" } },
                    [
                      _c("el-select", [_c("el-option")], 1),
                      _c("p", { staticClass: "tip" }, [
                        _vm._v("IMPS，任何时候应小于20万卢比"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Order No" } },
                    [_c("el-input", { attrs: { placeholder: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.UserID") } },
                    [_c("el-input", { attrs: { placeholder: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Amount" } },
                    [_c("el-input", { attrs: { placeholder: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Holder Name" } },
                    [_c("el-input", { attrs: { placeholder: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email" } },
                    [_c("el-input", { attrs: { placeholder: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.Phone") } },
                    [_c("el-input", { attrs: { placeholder: "" } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        { staticClass: "confirm", attrs: { type: "primary" } },
                        [_vm._v("Confirm")]
                      ),
                      _c("el-button", { staticClass: "confirm" }, [
                        _vm._v("Cancel"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "批量付款" } },
            [
              _c("p", { staticClass: "content-title" }, [
                _vm._v("请使用模板批量上传, 点击这里下载模板。"),
              ]),
              _c(
                "p",
                [
                  _c("el-button", { attrs: { size: "mini" } }, [
                    _vm._v("Download IMPS"),
                  ]),
                  _c("el-button", { attrs: { size: "mini" } }, [
                    _vm._v("Download UPI"),
                  ]),
                ],
                1
              ),
              _c(
                "p",
                { staticClass: "select-type" },
                [_vm._v(" Type: "), _c("el-select", [_c("el-option")], 1)],
                1
              ),
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "https://jsonplaceholder.typicode.com/posts/",
                    multiple: "",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("只支持上传csv/xlsx/xls文件, 并且文件大小应小于1M")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }